export enum BestDealFlagEnum {
  BiggestSaving,
  SameLender,
  LowestPayment,
}
